const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath,
  getFlattenedContentValues = _require.getFlattenedContentValues;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate readContentValuesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let sourceContentPaths = await evaluateSource(source.sourceContentPaths, content, parentContentPath, transientContext, nativeFunctions);
  if (sourceContentPaths === undefined) {
    return undefined;
  }
  if (!Array.isArray(sourceContentPaths)) {
    sourceContentPaths = [sourceContentPaths];
  }
  const requireAllValues = (await evaluateSource(source.requireAllValues, content, parentContentPath, transientContext, nativeFunctions)) || false;
  return getFlattenedContentValues(sourceContentPaths.map(sourcePath => appendPath(parentContentPath, sourcePath)), content, requireAllValues);
};
module.exports = {
  evaluate
};